module.exports = __webpack_public_path__ + "img/chat.f9735502.svg";